import { render, staticRenderFns } from "./editMembers.vue?vue&type=template&id=9c053c30&"
import script from "./editMembers.vue?vue&type=script&lang=ts&"
export * from "./editMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports